export const toOrdersHistory = '/customer/account/history/orders'
export const toWebOrdersHistory = '/customer/account/history/orders/web'
export const toWebOrderHistoryDetail = (webRef: string) =>
  `/customer/account/history/orders/web/${webRef}`
export const toStoreOrdersHistory = '/customer/account/history/orders/store'
export const toStoreOrderHistoryDetail = (externalRef: string) =>
  `/customer/account/history/orders/store/${externalRef}`
